import {
  useCreate,
  useDelete,
  useOne,
  useUpdate,
} from '@refinedev/core';

import { IBranch } from '../model/branch';

const RESOURCE = 'branches';

export const useBranchService = () => {
  const { mutate: createMutate, isLoading: loadingCreate } = useCreate();
  const { mutate: updateMutate, isLoading: loadingUpdate } = useUpdate();
  const { mutate: deleteMutate, isLoading: loadingDelete } = useDelete();

  function getById(id: string) {
    // TODO: React Hook is called in function
    return useOne<IBranch>({
      resource: RESOURCE,
      id,
    });
  }

  async function create(payload: IBranch): Promise<any> {
    return new Promise((resolve, reject) => {
      createMutate({
        resource: `${RESOURCE}/create`,
        values: payload,
      }, {
        onSuccess: (response) => resolve(response),
        onError: (error) => reject(error),
      });
    });
  }

  async function update(id: string, payload: IBranch): Promise<any> {
    return new Promise((resolve, reject) => {
      updateMutate({
        resource: `${RESOURCE}/:id/update`,
        id,
        values: payload,
      }, {
        onSuccess: (response) => resolve(response),
        onError: (error) => reject(error),
      });
    });
  }

  async function remove(id: string, rowVersion: string): Promise<any> {
    return new Promise((resolve, reject) => {
      deleteMutate({
        resource: `${RESOURCE}/:id/delete`,
        id,
        values: {
          row_version: rowVersion,
          branch_id: id,
        },
      }, {
        onSuccess: (response) => resolve(response),
        onError: (error) => reject(error),
      });
    });
  }

  return {
    loadingCreate,
    loadingUpdate,
    loadingDelete,
    getById,
    create,
    update,
    remove,
  };
};

export default useBranchService;
